import png1 from "./1.jpg";
import png2 from "./2.jpg";
import png3 from "./3.jpg";
import png4 from "./4.jpg";
export const nyyh = [
  {
    name: "查找流水",
    msgList: [
      { msg: "登录农业银行APP->顶部搜索【流水明细打印】->【流水打印】" },
      { imgs: [png1, png2] },
    ],
  },
  {
    name: "发送账单",
    msgList: [
      {
        msg: "时间选择【近一年】->输入专属邮件->确定",
      },
      { imgs: [png3, png4] },
    ],
  },
  {
    name: "注意事项",
    msgList: [
      {
        msg: "时间选择【近一年】",
      },
    ],
  },
];
